import { useState } from 'react';
import { useBlockRefreshIf } from '../../../../../hooks/useBlockRefreshIf';
import {
  DiscardChangesModalStateProps,
  UseDiscardChangesGuardParams,
} from '../discardChangesModal.types';

interface UseDiscardChangesGuardResult {
  requestClose: () => void;
  discardModalProps: DiscardChangesModalStateProps;
}

export const useDiscardChangesGuard = ({
  hasUnsavedChanges,
  onDiscard,
}: UseDiscardChangesGuardParams): UseDiscardChangesGuardResult => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  useBlockRefreshIf({ condition: hasUnsavedChanges });

  const requestClose = () => {
    if (hasUnsavedChanges) {
      setIsConfirmOpen(true);
      return;
    }

    onDiscard();
  };

  const handleConfirm = () => {
    setIsConfirmOpen(false);
    onDiscard();
  };

  const handleCancel = () => {
    setIsConfirmOpen(false);
  };

  return {
    requestClose,
    discardModalProps: {
      isOpen: isConfirmOpen,
      onConfirm: handleConfirm,
      onCancel: handleCancel,
    },
  };
};
